import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }

});

export const figure53 = {
chart: {
zoomType: 'xy',
animation: false,
marginTop: 50,
plotBackgroundColor: null,
plotBorderWidth: null,
plotShadow: false,
type: 'bar',
height: '700px',
backgroundColor: 'rgba(255, 255, 255, 0.0)',
style: {
 fontFamily: 'Montserrat'
}
},
credits: {
enabled: false
},
title: {
text: null
},
subtitle: {
text: null
},
plotOptions: {
series: {
borderWidth: 0,
stacking: 'normal',
}
},
exporting: {
enabled: false
},
xAxis: [{
tickWidth: 0,
labels: {
  groupedOptions: [{
			  style: {
					 transform: 'unset'
				 },
		  }],
		  style: {
					 transform: 'translateX(5px)'
				 },
				 align: 'right'
},
categories: [
{
  name: "Oceanía (excluidas Australia y Nueva Zelandia)",
  categories: ["Polinesia","Micronesia", "Melanesia"]
},
{
  name: "Asia occidental y África septentrional",
	categories: ["África septentrional", "Asia occidental"]
},
{
  name: "África subsahariana",
	categories: ["África meridional", "África occidental", "África central", "África oriental"]
},
{
  name: "Asia oriental y Asia sudoriental",
	categories: ["Asia sudoriental", "Asia oriental"]
},
{
  name: "Asia central y Asia meridional",
	categories: ["Asia central", "Asia meridional"]
},
{
  name: "América Latina y el Caribe",
	categories: ["América del Sur", "América central", "El Caribe"]
},
{
  name: "América septentrional y Europa",
	categories: ["Europa meridional", "Europa occidental", "Europa septentrional", "Europa oriental", "América septentrional"]
},

      ],
      lineColor: "#d7d7d7",
      tickColor: "#d7d7d7",
      tickLength: 16,
}],
yAxis: [{
  labels: {
		  style: {
				 fontWeight: 'normal',
				 color: '#999999',
				 fontSize: '12px'
			 },
	  },
	  min: 80,
	  max: 110,
	  tickInterval: 10,	
	  format: '{value}%',
	  gridLineWidth: 1,
	  floor: 0,

	  title: {
		  text: '',
		  style: {
				color: Highcharts.getOptions().colors[1]
			}
	  }
}],
tooltip: {
  shared: true,
  useHTML: true,
  hideDelay: 500,
  backgroundColor: null,
  borderWidth: 0,
  shadow: false,
  valueSuffix: '%',
  style: {
		  padding: 0
	  }
},
legend: {
  enabled: false,
},

series: [{
  name: '',
  color: '#bf9000',
  data: [
	 100.71,
	 98.16,
	 102.31,
	 103.19,
	 101.36,
	 100.24,
	 85.70,
	 104.29,
	 88.14,
	 97.72,
	 99.72,
	 99.99,
	 97.73,
	 97.91,
	 99.69,
	 99.62,
	 97.81,
	 102.48,
	 100.84,
	 98.77,
	 105.14,
	]
}]
}
   